<template>
  <Widget title="Scratchpad" width="600px" height="450px">
    <Notepad />
  </Widget>
</template>

<script>
import Widget from '../Widget.vue';
import Notepad from './Notepad.vue';

export default {
  components: { Notepad, Widget }
}
</script>